export const impersonateUser = (userId, onSuccess, onError) => {
  fetch(`/api/v2/super_users/sessions/impersonate`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ user_id: userId }),
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.success) {
        onSuccess(data.user, data.message);
      } else {
        onError(data.error || 'Impersonation failed');
      }
    })
    .catch((error) => {
      onError('Network error: ' + error.message);
    });
};

export const stopImpersonating = (onSuccess, onError) => {
  fetch(`/api/v2/super_users/sessions/impersonate`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.success) {
        onSuccess(data.user, data.message);
      } else {
        onError(data.error || 'Failed to stop session');
      }
    })
    .catch((error) => {
      onError('Network error: ' + error.message);
    });
};
